import { actionTypes } from './constants'

const initialState = {
  fetching: true,
  fields: {},
  selects: {} as Record<string, any>,
  cityList: {
    CityIDList: [] as Array<Record<string, any>>,
    City2IDList: [] as Array<Record<string, any>>,
    CityBusIDList: [] as Array<Record<string, any>>,
  },
  dynamicFields: {},
}

const reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case actionTypes.FETCH:
      return {
        ...state,
        fetching: true,
      }

    case actionTypes.FETCH_SUCCESS:
      const { selects, fields, dynamicFields, cityList } = payload
      return {
        ...state,
        fields,
        selects,
        dynamicFields,
        cityList,
        fetching: false,
      }

    case actionTypes.UPDATE_BIRTHPLACE_SELECT:
      return {
        ...state,
        selects: {
          ...state.selects,
          OrgBirthplaceHelper: state.selects.OrgBirthplaceHelper || state.selects.BirthplaceHelper,
          BirthplaceHelper: state.selects.OrgBirthplaceHelper
            ? [payload.addedItem, ...state.selects.OrgBirthplaceHelper]
            : [payload.addedItem, ...state.selects.BirthplaceHelper],
        },
      }

    case actionTypes.UPDATE_CITIES_LIST:
      const { cities, fieldName } = payload

      return {
        ...state,
        cityList: {
          ...state.cityList,
          [`${fieldName}List`]: cities,
        },
      }

    case actionTypes.FETCH_FAILURE:
      return {
        ...state,
        fetching: false,
      }

    case actionTypes.RESET:
      return initialState

    default:
      return state
  }
}

export default reducer
